import { gql } from "@apollo/client";

export const SUPPLIER_PRODUCT_VARIATION_FRAGMENT = gql`
  fragment SupplierProductManager_SupplierProductVariationFragment on SupplierProductVariation {
    sku
    availableStock {
      destinationCountry
      availableStock
    }
    calculatedCost {
      destinationCountry
      totalCostIncludingVAT
      totalCostExcludingVAT
      totalCostVAT
      VATRate
    }
    packaging
  }
`;

export const GET_SUPPLIER_PRODUCT = gql`
  query SupplierProductManager_GetSupplierProduct($id: String!) {
    supplierProduct(id: $id) {
      id
      supplierName
      name
      note
      variationTypes {
        id
        type
        typeValues {
          id
          value
          extraData
        }
      }
      variations {
        ...SupplierProductManager_SupplierProductVariationFragment
        typeValues {
          id
          value
          type {
            id
            type
          }
        }
      }
    }
  }
  ${SUPPLIER_PRODUCT_VARIATION_FRAGMENT}
`;

export const UPDATE_SUPPLIER_PRODUCT = gql`
  mutation SupplierProductManager_UpdateSupplierProduct($id: String!, $input: UpdateSupplierProductInput!) {
    updateSupplierProduct(id: $id, input: $input) {
      id
      name
      note
    }
  }
`;

export const CREATE_SUPPLIER_PRODUCT_VARIATION_TYPE = gql`
  mutation SupplierProductManager_CreateSupplierProductVariationType($input: CreateSupplierProductVariationTypeInput!) {
    createSupplierProductVariationType(input: $input) {
      id
      type
      supplierProductId
    }
  }
`;

export const UPDATE_SUPPLIER_PRODUCT_VARIATION_TYPE = gql`
  mutation SupplierProductManager_UpdateSupplierProductVariationType($id: ID!, $input: UpdateSupplierProductVariationTypeInput!) {
    updateSupplierProductVariationType(id: $id, input: $input) {
      id
      type
    }
  }
`;

export const DELETE_SUPPLIER_PRODUCT_VARIATION_TYPE = gql`
  mutation SupplierProductManager_DeleteSupplierProductVariationType($id: ID!) {
    deleteSupplierProductVariationType(id: $id)
  }
`;

export const CREATE_SUPPLIER_PRODUCT_VARIATION_TYPE_VALUE = gql`
  mutation SupplierProductManager_CreateSupplierProductVariationTypeValue($input: CreateSupplierProductVariationTypeValueInput!) {
    createSupplierProductVariationTypeValue(input: $input) {
      id
      typeId
      value
      extraData
    }
  }
`;

export const UPDATE_SUPPLIER_PRODUCT_VARIATION_TYPE_VALUE = gql`
  mutation SupplierProductManager_UpdateSupplierProductVariationTypeValue($id: ID!, $input: UpdateSupplierProductVariationTypeValueInput!) {
    updateSupplierProductVariationTypeValue(id: $id, input: $input) {
      id
      value
      extraData
    }
  }
`;

export const DELETE_SUPPLIER_PRODUCT_VARIATION_TYPE_VALUE = gql`
  mutation SupplierProductManager_DeleteSupplierProductVariationTypeValue($id: ID!) {
    deleteSupplierProductVariationTypeValue(id: $id)
  }
`;

export const GENERATE_SUPPLIER_PRODUCT_VARIATIONS = gql`
  mutation SupplierProductManager_GenerateSupplierProductVariations($supplierProductId: String!) {
    generateSupplierProductVariations(supplierProductId: $supplierProductId) {
      ...SupplierProductManager_SupplierProductVariationFragment
    }
  }
  ${SUPPLIER_PRODUCT_VARIATION_FRAGMENT}
`;

export const UPDATE_SUPPLIER_PRODUCT_VARIATION = gql`
  mutation SupplierProductManager_UpdateSupplierProductVariation($sku: String!, $supplierProductId: String!, $input: UpdateSupplierProductVariationInput!) {
    updateSupplierProductVariation(sku: $sku, supplierProductId: $supplierProductId, input: $input) {
      ...SupplierProductManager_SupplierProductVariationFragment
    }
  }
  ${SUPPLIER_PRODUCT_VARIATION_FRAGMENT}
`;

export const DELETE_SUPPLIER_PRODUCT_VARIATION = gql`
  mutation SupplierProductManager_DeleteSupplierProductVariation($sku: String!, $supplierProductId: String!) {
    deleteSupplierProductVariation(sku: $sku, supplierProductId: $supplierProductId)
  }
`;